import { Badge } from '../../components/ui/badge';
import { History, Undo2, Edit3, CheckCircle2, Sparkles, X } from 'lucide-react';

const iconMap = {
  edit: Edit3,
  submit: CheckCircle2,
  ai_fix: Sparkles,
};

const ClaimHistoryTimeline = ({ history, onUndo, onClose }) => {
  if (!history || history.length === 0) {
    return (
      <div style={{ padding: '12px 16px' }}>
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center gap-2">
            <History style={{ width: 13, height: 13, color: '#3b82f6' }} />
            <span style={{ fontSize: 12, fontWeight: 500 }}>Edit History</span>
          </div>
          {onClose && <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer' }}><X style={{ width: 12, height: 12, color: '#aaa' }} /></button>}
        </div>
        <p style={{ fontSize: 11, color: '#aaa', textAlign: 'center', padding: '16px 0' }}>No edits recorded yet</p>
      </div>
    );
  }

  return (
    <div style={{ padding: '12px 16px' }} data-testid="claim-history-timeline">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <History style={{ width: 13, height: 13, color: '#3b82f6' }} />
          <span style={{ fontSize: 12, fontWeight: 500 }}>Edit History</span>
          <Badge style={{ fontSize: 8, border: 'none', background: '#f0f0f0', color: '#888' }}>{history.length}</Badge>
        </div>
        <div className="flex items-center gap-1">
          {onUndo && history.length > 0 && (
            <button onClick={onUndo} className="flex items-center gap-1 transition-colors hover:opacity-80" style={{ fontSize: 10, fontWeight: 500, padding: '2px 8px', borderRadius: 6, background: '#f0f4ff', color: '#3b82f6', border: 'none', cursor: 'pointer' }} data-testid="undo-btn">
              <Undo2 style={{ width: 10, height: 10 }} /> Undo last
            </button>
          )}
          {onClose && <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '2px' }}><X style={{ width: 12, height: 12, color: '#aaa' }} /></button>}
        </div>
      </div>
      <div className="space-y-0" style={{ maxHeight: 200, overflowY: 'auto' }}>
        {history.slice().reverse().map((entry, i) => {
          const Icon = iconMap[entry.type] || Edit3;
          return (
            <div key={i} className="flex items-start gap-2 relative" style={{ paddingBottom: i < history.length - 1 ? 8 : 0 }}>
              {i < history.length - 1 && <div style={{ position: 'absolute', left: 7, top: 16, width: 1, height: 'calc(100% - 8px)', background: '#e8e8e8' }} />}
              <div style={{ width: 16, height: 16, borderRadius: '50%', background: entry.type === 'ai_fix' ? '#f5f3ff' : entry.type === 'submit' ? '#f0fdf4' : '#f0f4ff', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, marginTop: 1 }}>
                <Icon style={{ width: 9, height: 9, color: entry.type === 'ai_fix' ? '#6b5ce7' : entry.type === 'submit' ? '#22c55e' : '#3b82f6' }} />
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <p style={{ fontSize: 11, color: '#333', lineHeight: '1.3' }}>{entry.description}</p>
                <p style={{ fontSize: 9, color: '#bbb', marginTop: 1 }}>{entry.timestamp}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ClaimHistoryTimeline;
